/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import moment from 'moment-timezone';
import { useTheme } from 'emotion-theming';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import Text from '../../../../shared/components/Text/Text';
import { SUPERSET_DEFAULTS } from '../../../../shared/constants';
import {
  setCombineWithInfo, setCalendarItems, setNonDateBasedProgramItems, setRecurringCalendarItems, removeSuperSetPickerOpenById, setIsSupersetPickerOpen, persistSupersetGrouping, recordGestureParticipantCount,
} from '../../ducks/calendarActions';
import getCombineSharedBatchId from '../../utils/getCombineSharedBatchId';

const Container = styled('div')`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.surfaceElevated};
  border-radius: 4px;
  box-shadow: 0px 4px 8px 0px #3031331A;
  left: ${(props) => props.left || 0}px;
  top: ${(props) => props.top || 0}px;
  padding-bottom: 5px;
  padding-top: 5px;
  padding-left: 5px;
  gap: 5px;
  overflow-y: auto;
  min-width: 38px;
  z-index: 10000001;
  position: relative;
`;

/** The picker's rows: a clear/opt-out chip, then one chip per grouping
 * letter. The container is a single flex column, so arrow nav is a plain
 * 1-D list — not the 6-wide grid the transposed table's picker uses. */
const SUPERSET_NAV_OPTIONS = [
  { letter: null, color: null },
  ...Object.entries(SUPERSET_DEFAULTS).map(([letter, color]) => ({ letter, color })),
];

const SuperSetPickerPopup = ({
  content, left, top, openTop = false, spaceAbove = null, isRecurring = false, setSuperSetDropdownVisible = () => {}, inLineAction = false, bulkActionPicker = false, closeBulkActionPicker = () => {}, effectiveDate = null, dayNumber = null, isKeyboardNavActive = false, onExitSubmenu = () => {},
}) => {
  const dispatch = useDispatch();
  const containerRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState('none');
  const [chosenSuperset, setChosenSuperset] = useState(null);
  const [focusedIndex, setFocusedIndex] = useState(0);
  const chipRefs = useRef([]);
  const selectedProgramDayNumber = useSelector(
    (state) => state.calendar.data.selectedProgramDayNumber,
  );
  const selectedDate = useSelector((state) => state.calendar.data.selectedDate);
  /** Prefer the explicitly-passed effectiveDate (passed by week-view
   * rows and the month-view edit popover) so the items array we
   * mutate matches the exercise being edited, not the calendar's
   * currently-selected date. Falls back to selectedDate for day view
   * and bulk-action callers that don't pass it. */
  const dateForLookup = effectiveDate || selectedDate;
  const endpointFormattedDate = moment(dateForLookup).format('YYYY-MM-DD');
  const programType = useSelector((state) => state.calendar.data.programType);
  const viewType = useSelector((state) => state.calendar.data.viewType);
  const calendarItems = programType === 'free-form-program'
    ? useSelector((state) => state.calendar.data.nonDateBasedProgramItems[
      dayNumber || selectedProgramDayNumber
    ]?.exercises || []) : useSelector((state) => state.calendar.data.calendarItems[endpointFormattedDate]?.exercises || []);
  const beforeRecurringWorkouts = useSelector((state) => state.calendar.data.beforeRecurringWorkouts[endpointFormattedDate] || []);
  const afterRecurringWorkouts = useSelector((state) => state.calendar.data.afterRecurringWorkouts[endpointFormattedDate] || []);
  const calendarContainerScrollPosition = useSelector((state) => state.calendar.data.calendarContainerScrollPosition);
  const { colors } = useTheme();

  useEffect(() => {
    const updateMaxHeight = () => {
      if (containerRef?.current) {
        const rect = containerRef.current.getBoundingClientRect();
        const spaceBelow = window.innerHeight - rect.top - 10; /** 10px padding from bottom */
        setMaxHeight(spaceBelow);
      }
    };

    /** Initial set */
    updateMaxHeight();

    /** Add listener */
    window.addEventListener('resize', updateMaxHeight);

    /** Cleanup */
    return () => {
      window.removeEventListener('resize', updateMaxHeight);
    };
  }, [calendarContainerScrollPosition]);

  const handleClick = (letter, color) => {
    /** close inLine picker after selection */
    if (setSuperSetDropdownVisible) {
      setSuperSetDropdownVisible(false);
      if (inLineAction) {
        dispatch(removeSuperSetPickerOpenById(content.assignedId));
      }
    }

    /** close bulk action picker after selection */
    if (bulkActionPicker) {
      closeBulkActionPicker();
      dispatch(setIsSupersetPickerOpen(false));
    }

    setChosenSuperset({ letter, color });
    if (content.isMultiSelect) {
      /** create an new array of item that we can manipulate and set with
        * grouping letters and colors
        */
      const items = [...calendarItems];
      /** we need to track what the original items values were */
      const originalCalendarItems = calendarItems.map((item) => ({ ...item }));
      const selectedItems = Object?.values(content?.selectedIems);
      /** original target */
      const originalTarget = originalCalendarItems.find((item) => item.assignedId.toString() === selectedItems[0]?.assignedId.toString());
      /** index of the target within items, so we can replace it immutably */
      const targetIndex = items.findIndex((item) => item.assignedId.toString() === originalTarget?.assignedId.toString());

      /** Get all selected items from the original calendar list */
      const originalSelectedItems = originalCalendarItems.filter((item) => selectedItems.some((selected) => selected.assignedId.toString() === item.assignedId.toString()));

      /** Treat all selected items that aren't the target as sources */
      const originalSources = originalSelectedItems.filter(
        (item) => item.assignedId.toString() !== originalTarget?.assignedId.toString(),
      );

      /** Filter source items to only include ones that have a different groupingLetter */
      const filteredOriginalSources = originalSources.filter(
        (item) => item.groupingLetter !== letter,
      );

      /** Build new objects instead of mutating the shared items in place —
       * mutating would leave the array's element reference unchanged, which
       * makes MemoizedDraggableItems's shallow prop compare (in
       * DraggableContainer.js) skip re-rendering the row, and it also
       * corrupts the current Redux state object before it's even
       * dispatched. Splice the new copies into `items` at their index. */
      const updatedTargetItem = targetIndex >= 0
        ? { ...items[targetIndex], groupingLetter: letter, groupingColorCode: color }
        : null;
      if (targetIndex >= 0) {
        items[targetIndex] = updatedTargetItem;
      }
      const updatedSourceItems = filteredOriginalSources
        .map((src) => {
          const sourceIndex = items.findIndex((item) => item.assignedId.toString() === src.assignedId.toString());
          if (sourceIndex === -1) return null;
          const updatedSource = { ...items[sourceIndex], groupingLetter: letter, groupingColorCode: color };
          items[sourceIndex] = updatedSource;
          return updatedSource;
        })
        .filter(Boolean);

      if (programType === 'free-form-program') {
        dispatch(setNonDateBasedProgramItems(items, dayNumber || selectedProgramDayNumber));
      } else {
        dispatch(setCalendarItems(items, moment(effectiveDate).format('YYYY-MM-DD')));
      }

      /** Everything actually changing letter as a result of this pick - used
       * both to persist (month view) and, for day/week view, to feed
       * getCombineSharedBatchId (every changing item shares one batchId). */
      const changedItems = [
        ...(originalTarget?.groupingLetter === letter ? [] : [updatedTargetItem]),
        ...(updatedSourceItems.length > 0 ? updatedSourceItems : []),
      ].filter(Boolean);

      if (viewType === 'monthView') {
        /** Month view renders read-only items with no mounted table to consume
         * combineWithInfo, so persist the grouping directly. Skip
         * setCombineWithInfo so the single item open in MonthEditPopover (the
         * only mounted table) doesn't also fire and double-persist. */
        dispatch(persistSupersetGrouping({
          items: changedItems,
          formattedDate: endpointFormattedDate,
          programType,
          isRecurring,
          dayNumber: dayNumber || selectedProgramDayNumber,
          isMultiSelect: true,
        }));
      } else {
        const sharedBatchId = getCombineSharedBatchId(changedItems);
        if (sharedBatchId) {
          dispatch(recordGestureParticipantCount(sharedBatchId, changedItems.length));
        }
        dispatch(setCombineWithInfo({
        /** if either the target item of the sourceItem grouping letter is the same
        * as the original then we don't need to set something to trigger an update
        */
          target: originalTarget?.groupingLetter === letter ? null : updatedTargetItem,
          source: updatedSourceItems.length > 0 ? updatedSourceItems : null,
          isMultiSelect: true,
          sharedBatchId,
        }));
      }
    } else {
      /** create an new array of item that we can manipulate and set with
        * grouping letters and colors
        */
      const items = isRecurring === 'before' ? [...beforeRecurringWorkouts] : isRecurring === 'after' ? [...afterRecurringWorkouts] : [...calendarItems];

      /** we need to track what the original items values were */
      const originalCalendarItems = isRecurring === 'before' ? beforeRecurringWorkouts.map((item) => ({ ...item })) : isRecurring === 'after' ? afterRecurringWorkouts.map((item) => ({ ...item })) : calendarItems.map((item) => ({ ...item }));

      /** original target */
      const originalTarget = originalCalendarItems.find((item) => item.assignedId.toString() === content?.assignedId.toString());

      /** index of the target within items, so we can replace it immutably */
      const targetIndex = items.findIndex((item) => item.assignedId.toString() === originalTarget?.assignedId.toString());

      /** Build a new object instead of mutating the shared item in place —
       * mutating would leave the array's element reference unchanged, which
       * makes MemoizedDraggableItems's shallow prop compare (in
       * DraggableContainer.js) skip re-rendering the row, and it also
       * corrupts the current Redux state object before it's even
       * dispatched. Splice the new copy into `items` at the same index. */
      const updatedTargetItem = targetIndex >= 0
        ? { ...items[targetIndex], groupingLetter: letter, groupingColorCode: color }
        : null;
      if (targetIndex >= 0) {
        items[targetIndex] = updatedTargetItem;
      }

      if (isRecurring === 'before' || isRecurring === 'after') {
        dispatch(setRecurringCalendarItems(items, moment(effectiveDate).format('YYYY-MM-DD'), isRecurring));
      } else if (programType === 'free-form-program') {
        dispatch(setNonDateBasedProgramItems(items, dayNumber || selectedProgramDayNumber));
      } else {
        dispatch(setCalendarItems(items, moment(effectiveDate).format('YYYY-MM-DD')));
      }

      if (viewType === 'monthView') {
        /** Month view: persist directly (see multi-select branch) and skip
         * setCombineWithInfo so a mounted MonthEditPopover table can't double-fire. */
        const changedItems = originalTarget?.groupingLetter === letter ? [] : [updatedTargetItem];
        dispatch(persistSupersetGrouping({
          items: changedItems,
          formattedDate: endpointFormattedDate,
          programType,
          isRecurring,
          dayNumber: dayNumber || selectedProgramDayNumber,
          isMultiSelect: false,
        }));
      } else {
        dispatch(setCombineWithInfo({
          /** if either the target item of the sourceItem grouping letter is the same
         * as the original then we don't need to set something to trigger an update
         */
          target: originalTarget?.groupingLetter === letter ? null : updatedTargetItem,
          source: null,
          isMultiSelect: false,
        }));
      }
    }
  };

  /** Start on the letter this item already has when the coach drills in
   * from the options menu, so the first arrow press moves relative to the
   * current grouping rather than from the top of the list. */
  useEffect(() => {
    if (!isKeyboardNavActive) return;
    const currentLetter = chosenSuperset?.letter ?? content?.groupingLetter ?? null;
    const current = SUPERSET_NAV_OPTIONS.findIndex((opt) => opt.letter === currentLetter);
    setFocusedIndex(current >= 0 ? current : 0);
  }, [isKeyboardNavActive]);

  /** Owns the keyboard while drilled into from the options menu. The parent
   * menu bails out of its own listener whenever this is active, so no key
   * gets handled twice. */
  useEffect(() => {
    if (!isKeyboardNavActive) return undefined;

    const handleKeyDown = (e) => {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setFocusedIndex((prev) => Math.min(prev + 1, SUPERSET_NAV_OPTIONS.length - 1));
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        setFocusedIndex((prev) => Math.max(prev - 1, 0));
      } else if (e.key === 'Enter') {
        e.preventDefault();
        const option = SUPERSET_NAV_OPTIONS[focusedIndex];
        handleClick(option.letter, option.color);
      } else if (e.key === 'ArrowLeft' || e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        onExitSubmenu();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
    /** handleClick closes over the current calendar items, so the listener
     * has to be rebuilt whenever it is — a stale one would write the
     * grouping against a stale copy of the day. */
  }, [isKeyboardNavActive, focusedIndex, handleClick]);

  useEffect(() => {
    if (!isKeyboardNavActive) return;
    chipRefs.current[focusedIndex]?.scrollIntoView({ block: 'nearest' });
  }, [focusedIndex, isKeyboardNavActive]);

  function hexToRgba(hex, alpha) {
    let r = 0; let g = 0; let
      b = 0;

    /** 3 digits */
    if (hex.length === 4) {
      r = parseInt(hex[1] + hex[1], 16);
      g = parseInt(hex[2] + hex[2], 16);
      b = parseInt(hex[3] + hex[3], 16);
    } else if (hex.length === 7) {
      /** 6 digits */
      r = parseInt(hex[1] + hex[2], 16);
      g = parseInt(hex[3] + hex[4], 16);
      b = parseInt(hex[5] + hex[6], 16);
    }

    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  }

  return (

    <Container
      ref={containerRef}
      onClick={(e) => {
        e.stopPropagation();
      }}
      left={left}
      top={top}
      style={{ maxHeight: openTop ? spaceAbove : maxHeight }}
    >
      <div
        key='remove'
        ref={(el) => { chipRefs.current[0] = el; }}
        onMouseDown={(e) => {
          e.preventDefault();
          handleClick(null, null);
        }}
        style={{
          backgroundColor: colors.surfaceElevated,
          width: 28,
          minWidth: 28,
          height: 28,
          minHeight: 28,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '4px',
          cursor: 'pointer',
          border: chosenSuperset?.letter === null ? `2px solid ${colors.hover}` : `2px solid ${colors.borderLight}`,
          /** Distinct from the solid selected border, so "where the
           * keyboard is" reads separately from "what's applied". */
          boxShadow: isKeyboardNavActive && focusedIndex === 0 ? '0 0 0 2px #BFDBFE' : 'none',
        }}
      >
        <IcomoonReact
          iconSet={iconSet}
          size={16}
          icon='opt-out'
          color={colors.textSecondary}
        />
      </div>
      {Object.entries(SUPERSET_DEFAULTS).map(([letter, color], index) => {
        const colorWithOpacity = hexToRgba(color, 0.2);
        return (
          <div
            key={letter}
            ref={(el) => { chipRefs.current[index + 1] = el; }}
            onMouseDown={(e) => {
              e.preventDefault();
              handleClick(letter, color);
            }}
            style={{
              backgroundColor: colorWithOpacity,
              width: 28,
              minWidth: 28,
              height: 28,
              minHeight: 28,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: '4px',
              cursor: 'pointer',
              border: chosenSuperset?.letter === letter && `2px solid ${colors.hover}`,
              boxShadow: isKeyboardNavActive && focusedIndex === index + 1 ? '0 0 0 2px #BFDBFE' : 'none',
            }}
          >
            <Text fontSize='13px'>{letter}</Text>
          </div>
        );
      })}
    </Container>
  );
};

export default SuperSetPickerPopup;
